import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setUser } from '../../../store/slices/appSlice'
import SpinnerOverlay from '../../../components/SpinnerOverlay/SpinnerOverlay'
import { persistor } from '../../../store/store'

export default () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.app)

  useEffect(() => {
    const logout = (errorMessage = null) => {
      axios
        .get('/api/auth/logout')
        .then((response) => response.data)
        .then((logoutResponse) => {
          persistor.purge().then(() => {
            if (logoutResponse.loggedOut) {
              const { redirectUrl } = logoutResponse
              navigate('/auth/logout-external', {
                state: { redirectUrl, ...(errorMessage && { errorMessage }) },
              })
            } else {
              navigate(`/auth/login${errorMessage ? `?error=${errorMessage}` : ''}`)
            }
          })
        })
    }

    if (user) {
      navigate('/')
    } else {
      axios
        .get('/api/user')
        .then((response) => response.data.user)
        .then((userResponse) => {
          dispatch(setUser(userResponse))
        })
        .catch((e) => {
          logout(
            e.status === 401 ? 'login.failed-credentials-message' : 'login.internal_server_error',
          )
        })
    }
  }, [dispatch, navigate, user])

  return <SpinnerOverlay visible />
}
